import { postRequest } from 'js/helpers/apiClient';
import { useMutationWithLogout } from 'js/hooks/useMutationWithLogout';
import apiRoutes from '../../../api-routes';

export const useCreateIdentity = (options) =>
  useMutationWithLogout(async ({ data }) => {
    const { data: createData } = await postRequest({
      url: apiRoutes.RECIPIENT,
      data,
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });

    return createData;
  }, options);
